// posSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchPosCustomerDetails, fetchPosItemOffers, fetchStockItems } from '../Action';


const initialState: any = {
  stockItems: [],
  loading: false,
  error: null,
  postofferStockitems: [],
  PosCustomerDetails:[]

};

const posSlice = createSlice({
  name: 'pos',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStockItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStockItems.fulfilled, (state, action) => {
        state.loading = false;
        state.stockItems = action.payload;
      })
      .addCase(fetchStockItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      .addCase(fetchPosItemOffers.pending, (state) => {
        state.loading = true;
        state.error = null
      })

      .addCase(fetchPosItemOffers.fulfilled, (state, action) => {
        
        state.loading = false;
        state.postofferStockitems = action.payload
      })

      .addCase(fetchPosItemOffers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      .addCase(fetchPosCustomerDetails.pending,(state)=>{
        state.loading=false;
        state.error=null
      })

      .addCase(fetchPosCustomerDetails.fulfilled,(state,action)=>{
        
        state.loading=false
        state.PosCustomerDetails= action.payload
      })

       .addCase(fetchPosCustomerDetails.rejected,(state,action)=>{
        
        state.loading=false
        state.error= action.payload
      })
      
  },
});



export default posSlice.reducer;
